export const userRole = {
  admin: "admin",
  user: "user",
}
